import $ from 'jquery'

const SCROLL_TOP_TRIGGER = 10

export const initHeaderOnScroll = () => {
    const $headerEl = $('.header--container')

    $(window).on('scroll', () => {
        $(window).scrollTop() > SCROLL_TOP_TRIGGER && $headerEl.addClass('header--active')
        $(window).scrollTop() <= SCROLL_TOP_TRIGGER && $headerEl.removeClass('header--active')
    })
}
